<template>
  <div class="radio-component has-no-style">
    <ul class="style-wrap" :style="getStyle">
      <li class="radio"
        ref="radio"
        v-for="(item, index) in radioLists"
        :key="index"
        :style="getRadioStyle(index)"
        :class="options.activeIndex == index ? 'active' : ''"
        @mouseenter.stop.self="mouseoverEv(index)"
        @mouseleave.stop.self="mouseLeaveEv(index)"
        @click="switchContent(index)"
      >
        <span v-if="getIconPosition === 'right'">{{item.name}}</span>
        <!-- 默认图标样式 -->
        <img v-if="iconType1 === 'img' && !iconSrc1 && options.activeIndex != index && isShowIcon" src="../../../assets/images/icon-radio3.png" :style="getIconImgStyle"><!-- 没有上传图标时 -->
        <!-- <span v-if="iconType1 === 'icon' && iconSrc1" :class="iconSrc1" :style="getIconStyle"></span> -->
        <cxIcon v-if="iconType1 === 'icon' && iconSrc1 && isShowIcon && options.activeIndex !== index" iconSrcName ="iconSrc1" :options="options" :iconStyle="getIconStyle"></cxIcon>
        <img v-else-if="iconType1 === 'img' && iconSrc1 && isShowIcon && options.activeIndex !== index" :src="iconSrc1" :style="getIconImgStyle"/>
        <!-- 选中图标样式 -->
        <img v-if="iconType2 === 'img' && !iconSrc2 && options.activeIndex === index && isShowIcon" src="../../../assets/images/icon-radio4.png" :style="getIconImgStyle"><!-- 没有上传图标时 -->
        <cxIcon v-if="iconType2 === 'icon' && iconSrc2 && options.activeIndex === index && isShowIcon" iconSrcName ="iconSrc2" :options="options" :iconStyle="getIconStyle2" ></cxIcon>
        <img v-else-if="iconType2 === 'img' && iconSrc2 && options.activeIndex === index && isShowIcon" :src="iconSrc2" :style="getIconImgStyle"/>
        <!-- <span v-if="iconType1 === 'icon' && iconSrc2 && options.activeIndex == index" :class="iconSrc2" :style="getIconStyle"></span>
        <img v-else-if="iconType1 === 'img' && iconSrc2 && options.activeIndex == index" :src="iconSrc2" :style="getIconImgStyle"/> -->
        <span v-if="getIconPosition === 'left'">{{item.name}}</span>
        <!-- 分隔符 -->
        <div class="divide-box" v-if="index !== radioLists.length - 1 && options.showDivide" :style="getDivideStyle('img')">
          <span class="line" :style="getDivideStyle('line')" v-if="options.divideType !== 'custom'"></span>
          <cxIcon class="icon" v-if="divideIconType === 'icon' && options.divideType === 'custom'" :options="options" :iconStyle="getDivideStyle('icon')" iconSrcName="divideIconSrc"></cxIcon>
          <img class="icon" v-else-if="divideIconType === 'img' && divideIconSrc && options.divideType === 'custom'" :src="divideIconSrc" :style="getDivideStyle('img')" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import eventMixin from "utils/event/eventMixin.js"
import { isSsrPage } from "utils/index"
export default {
  mixins: [eventMixin],
  name: "cxRadio",
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    radioLists() {
      return this.options.radioLists
    },
    getStyle() {
      let borderW = ""
      this.checkAndSetVal(this.options, "borderWidth", "borderWidth", 1)
      if (Array.isArray(this.options.borderWidth)) {
        this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.borderWidth}px`
      }
      return {
        ...this.bgStyle,
        height: this.options.height + "px",
        opacity: this.options.opacity,
        "box-shadow": this.boxShadowStyle,
        padding: this.getPaddingStyle,
        "border-top-left-radius": this.options.borderTopLeftRadius + "px",
        "border-top-right-radius": this.options.borderTopRightRadius + "px",
        "border-bottom-right-radius": this.options.borderBottomRightRadius + "px",
        "border-bottom-left-radius": this.options.borderBottomLeftRadius + "px",
        "border-style": this.options.borderStyle,
        "border-color": this.$parseColor(this.options.borderColor),
        "border-width": borderW,
        "border-top-left-radius":
          this.options.shapeType == "round"
            ? this.options.borderTopLeftRadius
            : this.options.borderTopLeftRadius + "px",
        "border-top-right-radius":
          this.options.shapeType == "round"
            ? this.options.borderTopLeftRadius
            : this.options.borderTopRightRadius + "px",
        "border-bottom-left-radius":
          this.options.shapeType == "round"
            ? this.options.borderTopLeftRadius
            : this.options.borderBottomLeftRadius + "px",
        "border-bottom-right-radius":
          this.options.shapeType == "round"
            ? this.options.borderTopLeftRadius
            : this.options.borderBottomRightRadius + "px"
      }
    },
    getRadioStyle() {
      return function (index) {
        if (index === this.options.activeIndex || index === this.hoverIndex) {
          return this.activeStyle
        } else {
          return this.defaultStyle
        }
      }

    },
    getDivideMargin() {
      const divideWidth = this.options.divideWidth || 1
      let divideMargin = 0
      if (this.options.marginRight !== undefined) divideMargin = -(this.options.marginRight + divideWidth) / 2
      return divideMargin
    },
    defaultStyle() {
      return {
        "font-family": this.options.fontFamily,
        "font-size": this.options.fontSize + "px",
        "font-weight": this.options.fontWeight,
        "font-style": `${this.options.fontStyle}`,
        "text-decoration": this.options.textDecoration,
        lineHeight: `${this.options.lineHeightType === "%" ? this.options.lineHeight + "%": this.options.lineHeight + 'px'}`,
        // "letter-spacing": this.options.letterSpacing + "px",
        "letter-spacing": this.options.letterSpacingType === "%" ? (this.options.letterSpacing / 100) + "em" : this.options.letterSpacing + "px",
        "writing-mode": this.options.writingMode,
        "text-align": this.options.textAlign,
        color: this.$parseColor(this.options.color, {
          isThemeColor: this.options.textIsThemeColor
        }),
        padding: this.getItemPaddingStyle,
        "margin-right": this.options.marginRight + "px",
        "--divideMargin": this.getDivideMargin + "px",
      }
    },
    activeStyle() {
      return {
        "font-family": this.options.hoverFontFamily,
        "font-size": this.options.hoverFontSize + "px",
        "font-weight": this.options.hoverFontWeight,
        "font-style": `${this.options.hoverFontStyle}`,
        "text-decoration": this.options.hoverTextDecoration,
        lineHeight: `${this.options.hoverLineHeightType === "%" ? this.options.hoverLineHeight + "%": this.options.hoverLineHeight + 'px'}`,
        "letter-spacing": this.options.hoverLetterSpacingType === "%" ? (this.options.hoverLetterSpacing / 100) + "em" : this.options.hoverLetterSpacing + "px",
        "writing-mode": this.options.hoverWritingMode,
        "text-align": this.options.hoverTextAlign,
        color: this.$parseColor(this.options.hoverColor, {
          isThemeColor: this.options.hoverTextIsThemeColor
        }),
        padding: this.getItemPaddingStyle,
        "margin-right": this.options.marginRight + "px",
        "--divideMargin": this.getDivideMargin + "px",
      }
    },
    getItemPaddingStyle() {
      let padding = `${this.options.itemPadding}px`
      if (!this.options.itemPaddingTypeFlag || this.options.itemPaddingTypeFlag === 2) {
        padding = ` ${this.options.itemPaddingTop}px  ${this.options.itemPaddingRight}px  ${this.options.itemPaddingBottom}px  ${this.options.itemPaddingLeft}px`
      }
      return padding
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.background
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("bgColorIsThemeColor") ? this.options.bgColorIsThemeColor : false,
            color: this.options.bgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage +=
                dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    boxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.boxShadowH)) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.boxShadowH[index]}px ${_this.options.boxShadowV[index]}px ${_this.options.boxShadowBlur[index]}px ${_this.options.boxShadowSpread[index]}px ${_this.$parseColor(_this.options.boxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return tmpStyle
    },
    iconSrc1() {
      return this.options ? this.options.iconSrc1 : ""
    },
    iconType1() {
      return this.options ? this.options.iconType1 : "img"
    },
    iconSrc2() {
      return this.options ? this.options.iconSrc2 : ""
    },
    iconType2() {
      return this.options ? this.options.iconType2 : "img"
    },
    getIconPosition() {
      return this.options ? this.options.iconPosition : "left"
    },
    getMargin() {
      return this.options.iconPosition === "left"
        ? `0 ${this.options.iconMargin}px 0 0`
        : `0 0 0 ${this.options.iconMargin}px`
    },
    getIconStyle() {
      return {
        // color: this.options.iconColorIsThemeColor ? this.themeColor : this.options.iconColor,
        color: this.$parseColor(this.options.iconColor, {
          isThemeColor: this.options.iconColorIsThemeColor
        }),
        "--color": this.$parseColor(this.options.iconColor, {
          isThemeColor: this.options.iconColor
        }),
        fontSize: this.options.iconWidth + "px",
        width: this.options.iconWidth + "px",
        height: this.options.iconWidth + "px",
        margin: this.getMargin,
        "vertical-align": "middle",
      }
    },
    getIconStyle2() {
      return {
        color: this.$parseColor(this.options.iconColor2, {
          isThemeColor: this.options.iconColorIsThemeColor2
        }),
        "--color": this.$parseColor(this.options.iconColor2, {
          isThemeColor: this.options.iconColorIsThemeColor2
        }),
        fontSize: this.options.iconWidth + "px",
        width: this.options.iconWidth + "px",
        height: this.options.iconWidth + "px",
        margin: this.getMargin,
        "vertical-align": "middle",
      }
    },
    getIconImgStyle() {
      return {
        width: this.options.iconWidth + "px",
        margin: this.getMargin,
        "vertical-align": "unset",
      }
    },
    getPaddingStyle() {
      let padding = `${this.options.padding}px`
      if (!this.options.paddingTypeFlag || this.options.paddingTypeFlag === 2) {
        padding = ` ${this.options.paddingTop}px  ${this.options.paddingRight}px  ${this.options.paddingBottom}px  ${this.options.paddingLeft}px`
      }
      return padding
    },
    themeColor() {
      return isSsrPage() ? this.$store.state.page.themeColor : this.$store.state[this.request_prefix].page.themeColor
    },
    isShowIcon() {
      return this.options.hasOwnProperty("isShowIcon") ? this.options.isShowIcon : true
    },
    divideIconSrc() {
      return this.options ? this.options.divideIconSrc : ""
    },
    divideIconType() {
      return this.options ? this.options.divideIconType : "icon"
    },
    getDivideStyle() {
      return function(type) {
        let style = {}
        const color = this.$parseColor(this.options.divideIconColor, {
          isThemeColor: this.options.divideIconColorIsThemeColor
        })
        const width = this.options.divideWidth || 1
        const height = this.options.divideHeight || 24
        style = {
          width: width + "px",
          height: height + "px",
        }
        switch (type) {
          case "line":
            style = {
              ...style,
              backgroundColor: color
            }
            break
          case "icon":
            style = {
              ...style,
              "--color": color,
            }
            break
          case "img":
            break
        }
        return style
      }
    }
  },
  data() {
    return {
      hoverIndex: undefined
    }
  },
  methods: {
    async updateData() {},
    checkAndSetVal(opt, key, optname, val) {
      //兼容为NaN或没有的数值数据
      if (!opt.hasOwnProperty(key) || opt[key] !== opt[key] || opt[key] === null || opt[key] === undefined) {
        this.$changeOptionsEV(val, optname, false, null, this.myid)
        return val
      }
    },
    mouseoverEv(index) {
      let _this = this
      this.hoverIndex = index
      const styleObj = this.activeStyle
      Object.keys(styleObj).forEach(key => {
        _this.$refs.radio[index].style[key] = styleObj[key]
      })
    },
    mouseLeaveEv(index) {
      let _this = this
      this.hoverIndex = undefined
      const styleObj = this.defaultStyle
      Object.keys(styleObj).forEach(key => {
        if (index !== _this.options.activeIndex) {
          _this.$refs.radio[index].style[key] = styleObj[key]
        }
      })
    },
    switchContent: function (index) {
      let oldActiveIndex = this.options.activeIndex
      if (this.options.activeIndex === index) {
        return
      }
      const param = {
        ...this.ids,
        option_name: "value",
        option_val: this.radioLists[index].name
      }
      this.$store.dispatch(this.request_prefix + "/changeOptions", param)
      setTimeout(() => {
        // 使用延时是为了 激活外层的vdr
        const tempIds = { ...this.ids }
        this.$store.commit("states/changeActiveID", tempIds)
        console.log("inini", this.ids.uid)
        this.$store.dispatch(this.request_prefix + "/changeTabsActiveIndex", {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          directionIndex: this.ids.directionIndex,
          elementInLayoutId: this.ids.elementInLayoutId,
          activeIndex: index,
          uid: this.ids.uid,
          singleTabs: this.options.singleTabs || false,
          elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
          path: this.myid.path,
        })
        this.mouseLeaveEv(oldActiveIndex)
        this.mouseoverEv(index)
      }, 10)
    }
  }
}
</script>

<style scoped>
  .radio {
    position: relative;
    float: left;
    display: flex;
    align-items: center;
  }
  ::v-deep.radio svg * {
    stroke: var(--color);
  }
.divide-box {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: var(--divideMargin);
}
.divide-box .line,
.divide-box .icon {
  display: block;
}
</style>
